export default __webpack_public_path__ + "static/media/phone.cec2bfd9.svg";